export const ManfrediteAvailabilityStatusValues = ['ACTIVE', 'OPEN', 'NOT AVAILABLE'];
//# sourceMappingURL=manfredite-availability-status.js.map